import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import contextProvider from "app/contextProvider";
import { Row, Col, Badge } from "reactstrap";

import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";

import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOButton from "app/_L1_components/Elements/ReactOButton";

class SearchResults extends _ReactOBaseComponent {
  constructor(props) {
    //	console.log("DEBUG :: SearchResults _ constructor");
    var initState = {
      query: "",
      persistentState: {
        query: "",
        resultsCategory: "ALL",
        searchResults: {},
        filteredResults: [],
      },
    };
    super(props, initState);

    this._DEBOUNCE_TOUT = null;
    this.apiStore = null;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    //	console.log("DEBUG :: SearchResults _ onComponentDidMount");
    if (this.getAppContext().getLocalStorageService().isSet("search_persistent_state")) {
      this.setState((prev_state) => {
        prev_state.persistentState = this.getAppContext()
          .getLocalStorageService()
          .get("search_persistent_state");
        return prev_state;
      });
    }
    this.apiStore = this.getAppContext().getApiStoreService();
    this.actionShelf = this.getAppContext()
      .getActionsShelfService()
      .createNewShelf("searchActions");
    this.actionShelf.registerAction({
      key: "updateQuery",
      call: (new_query) => {
        //	this.context._LayoutFixedBody.open();
        if (this._DEBOUNCE_TOUT) {
          clearTimeout(this._DEBOUNCE_TOUT);
        }
        if (new_query != "") {
          this.setState(
            {
              loading: true,
              query: new_query,
            },
            () => {
              this._DEBOUNCE_TOUT = setTimeout(() => {
                this.apiStore.fire("search", {
                  data: {
                    query: new_query,
                  },
                  ___onSuccess: (status, data) => {
                    this.setState(
                      (prev_state) => {
                        prev_state.loading = false;
                        prev_state.persistentState.searchResults = data;
                        prev_state.persistentState.query = new_query;
                        return prev_state;
                      },
                      () => {
                        this.getAppContext()
                          .getLocalStorageService()
                          .set("search_persistent_state", this.state.persistentState);
                      }
                    );
                    // console.log(this.state);
                    this.setResultsCategory("ALL");
                  },
                });
              }, 200);
            }
          );
        } else {
          this.setState({
            loading: false,
            query: new_query,
          });
        }
      },
    });
  }

  onComponentWillUnmount() {
    this.actionShelf.unregister("searchActions");
  }

  onComponentDidUpdate(prev_props, prev_state, snapshot) {
    //	console.log("onComponentDidUpdate");
  }

  onShouldComponentUpdate(next_props, next_state) {
    //	console.log("onShouldComponentUpdate");
    //	if (next_state.query != this.state.query) {
    //		return true;
    //	} else {
    //		return false;
    //	}
    return true;
  }

  setResultsCategory(new_cat) {
    let filteredResults = [];

    let _account_user = this.getAppContext().authHandler.getAccountData().user;

    this._netProbe =
      _account_user == "intesa_dev" ||
      _account_user == "intesasanpaolo" ||
      this.getAppContext().conf.IS_NETPROBE;

    if (new_cat == "ALL" || new_cat == "PROBE") {
      filteredResults.push({
        type: "PROBE",
        results: (this.state.persistentState.searchResults.results || []).filter(
          (value) => {
            return value.type == "PROBE";
          }
        ),
      });
    }

    if (new_cat == "ALL" || new_cat == "MEASURE") {
      let runningMeasures = (
        this.state.persistentState.searchResults.results || []
      ).filter((value) => {
        return (
          value.type == "MEASURE" &&
          value.data.measure.paused == null &&
          value.data.measure.archived == null
        );
      });

      let pausedMeasures = (
        this.state.persistentState.searchResults.results || []
      ).filter((value) => {
        return (
          value.type == "MEASURE" &&
          value.data.measure.paused != null &&
          value.data.measure.archived == null
        );
      });

      let archivedMeasures = (
        this.state.persistentState.searchResults.results || []
      ).filter((value) => {
        return value.type == "MEASURE" && value.data.measure.archived != null;
      });

      filteredResults.push({
        type: "MEASURE",
        results: runningMeasures.concat(pausedMeasures, archivedMeasures),
      });
    }

    if (new_cat == "ALL" || new_cat == "TEST") {
      filteredResults.push({
        type: "TEST",
        results: (this.state.persistentState.searchResults.results || []).filter(
          (value) => {
            return value.type == "TEST";
          }
        ),
      });
    }

    if (!this._netProbe) {
      if (new_cat == "ALL" || new_cat == "ESSID") {
        filteredResults.push({
          type: "ESSID",
          results: (this.state.persistentState.searchResults.results || []).filter(
            (value) => {
              return value.type == "ESSID";
            }
          ),
        });
      }

      if (new_cat == "ALL" || new_cat == "AP") {
        filteredResults.push({
          type: "AP",
          results: (this.state.persistentState.searchResults.results || []).filter(
            (value) => {
              return value.type == "AP";
            }
          ),
        });
      }
    }

    this.setState(
      (prev_state) => {
        prev_state.persistentState.resultsCategory = new_cat;
        prev_state.persistentState.filteredResults = filteredResults;
        return prev_state;
      },
      () => {
        this.getAppContext()
          .getLocalStorageService()
          .set("search_persistent_state", this.state.persistentState);
      }
    );
  }

  onRender() {
    //	console.log("onRender");

    if (this.state.query == "" && this.state.persistentState.query == "") {
      return (
        <div className="mt-5 text-center text-gray400">
          <small className="display-4 d-none">Type to search</small>
        </div>
      );
    }

    let _all = this.state.persistentState.searchResults.results || [];
    let _probes = _all.filter((value) => {
      return value.type == "PROBE";
    });
    let _measures = _all.filter((value) => {
      return value.type == "MEASURE";
    });
    let _essids = _all.filter((value) => {
      return value.type == "ESSID";
    });
    let _tests = _all.filter((value) => {
      return value.type == "TEST";
    });
    let _aps = _all.filter((value) => {
      return value.type == "AP";
    });

    let _now = parseInt(this.getAppContext().momentjs().format("X"));
    return (
      <div className="search-results pt-4">
        {_all.length ? (
          <Section designType="narrow">
            <Row>
              <Col>
                <ReactOButton
                  className="w-100 text-left d-flex"
                  color={
                    this.state.persistentState.resultsCategory == "ALL"
                      ? "primary"
                      : "light"
                  }
                  size="lg"
                  onClick={() => {
                    this.setResultsCategory("ALL");
                  }}
                >
                  <div className="flex-grow-1">All</div>
                  {_all.length ? (
                    <div>
                      <Badge
                        color={
                          !this.state.persistentState.resultsCategory ||
                          this.state.persistentState.resultsCategory == "ALL"
                            ? "light"
                            : "secondary"
                        }
                        pill
                      >
                        {_all.length}
                      </Badge>
                    </div>
                  ) : null}
                </ReactOButton>
              </Col>
              <Col>
                <ReactOButton
                  className="w-100 text-left d-flex"
                  color={
                    this.state.persistentState.resultsCategory == "PROBE"
                      ? "primary"
                      : "light"
                  }
                  size="lg"
                  disabled={
                    !(this.state.persistentState.searchResults.results || []).filter(
                      (value) => {
                        return value.type == "PROBE";
                      }
                    ).length
                  }
                  onClick={() => {
                    this.setResultsCategory("PROBE");
                  }}
                >
                  <div className="flex-grow-1">
                    <span className="icon-probe mr-2" />
                    Probe
                  </div>
                  {_probes.length ? (
                    <div>
                      <Badge
                        color={
                          !this.state.persistentState.resultsCategory ||
                          this.state.persistentState.resultsCategory == "PROBE"
                            ? "light"
                            : "secondary"
                        }
                        pill
                      >
                        {_probes.length}
                      </Badge>
                    </div>
                  ) : null}
                </ReactOButton>
              </Col>
              <Col>
                <ReactOButton
                  className="w-100 text-left d-flex"
                  color={
                    this.state.persistentState.resultsCategory == "MEASURE"
                      ? "primary"
                      : "light"
                  }
                  size="lg"
                  disabled={
                    !(this.state.persistentState.searchResults.results || []).filter(
                      (value) => {
                        return value.type == "MEASURE";
                      }
                    ).length
                  }
                  onClick={() => {
                    this.setResultsCategory("MEASURE");
                  }}
                >
                  <div className="flex-grow-1">
                    <span className="icon-graph-bar mr-2" />
                    Measure
                  </div>
                  {_measures.length ? (
                    <div>
                      <Badge
                        color={
                          this.state.persistentState.resultsCategory == "MEASURE"
                            ? "light"
                            : "secondary"
                        }
                        pill
                      >
                        {_measures.length}
                      </Badge>
                    </div>
                  ) : null}
                </ReactOButton>
              </Col>
              {!this._netProbe ? (
                <Col>
                  <ReactOButton
                    className="w-100 text-left d-flex"
                    color={
                      this.state.persistentState.resultsCategory == "ESSID"
                        ? "primary"
                        : "light"
                    }
                    size="lg"
                    disabled={
                      !(this.state.persistentState.searchResults.results || []).filter(
                        (value) => {
                          return value.type == "ESSID";
                        }
                      ).length
                    }
                    onClick={() => {
                      this.setResultsCategory("ESSID");
                    }}
                  >
                    <div className="flex-grow-1">
                      <span className="icon-wifi mr-2" />
                      Net/Essid
                    </div>
                    {_essids.length ? (
                      <div>
                        <Badge
                          color={
                            this.state.persistentState.resultsCategory == "ESSID"
                              ? "light"
                              : "secondary"
                          }
                          pill
                        >
                          {_essids.length}
                        </Badge>
                      </div>
                    ) : null}
                  </ReactOButton>
                </Col>
              ) : null}
              <Col>
                <ReactOButton
                  className="w-100 text-left d-flex"
                  color={
                    this.state.persistentState.resultsCategory == "TEST"
                      ? "primary"
                      : "light"
                  }
                  size="lg"
                  disabled={
                    !(this.state.persistentState.searchResults.results || []).filter(
                      (value) => {
                        return value.type == "TEST";
                      }
                    ).length
                  }
                  onClick={() => {
                    this.setResultsCategory("TEST");
                  }}
                >
                  <div className="flex-grow-1">
                    <span className="icon-script mr-2" />
                    Test
                  </div>
                  {_tests.length ? (
                    <div>
                      <Badge
                        color={
                          this.state.persistentState.resultsCategory == "TEST"
                            ? "light"
                            : "secondary"
                        }
                        pill
                      >
                        {_tests.length}
                      </Badge>
                    </div>
                  ) : null}
                </ReactOButton>
              </Col>
              {!this._netProbe ? (
                <Col>
                  <ReactOButton
                    className="w-100 text-left d-flex"
                    color={
                      this.state.persistentState.resultsCategory == "AP"
                        ? "primary"
                        : "light"
                    }
                    size="lg"
                    disabled={
                      !(this.state.persistentState.searchResults.results || []).filter(
                        (value) => {
                          return value.type == "AP";
                        }
                      ).length
                    }
                    onClick={() => {
                      this.setResultsCategory("AP");
                    }}
                  >
                    <div className="flex-grow-1">
                      <span className="icon-router mr-2" />
                      AP
                    </div>
                    {_aps.length ? (
                      <div>
                        <Badge
                          color={
                            this.state.persistentState.resultsCategory == "AP"
                              ? "light"
                              : "secondary"
                          }
                          pill
                        >
                          {_aps.length}
                        </Badge>
                      </div>
                    ) : null}
                  </ReactOButton>
                </Col>
              ) : null}
            </Row>
          </Section>
        ) : null}
        <Section className="pt-4" designType="narrow">
          <_LoadingWrapper loadingPlug={this.state.loading}>
            {this.state.persistentState.searchResults.results &&
            this.state.persistentState.searchResults.results.length ? (
              <div>
                <div className="text-right text-muted mb-2">
                  <small>
                    Found{" "}
                    <strong>
                      {this.state.persistentState.searchResults.results.length}
                    </strong>{" "}
                    results in all categories for "
                    <strong>{this.state.persistentState.query}</strong>"
                  </small>
                </div>

                {this.state.persistentState.filteredResults
                  ? this.state.persistentState.filteredResults.map(
                      (_C_category_results, _C_cat_res_idx) => {
                        // console.log(_C_category_results);
                        let _category_name =
                          _C_category_results.type == "PROBE"
                            ? "Probes"
                            : _C_category_results.type == "MEASURE"
                            ? "Measures"
                            : _C_category_results.type == "ESSID"
                            ? "Networks/Essid"
                            : _C_category_results.type == "TEST"
                            ? "Tests"
                            : _C_category_results.type == "AP"
                            ? "APs"
                            : "";
                        return (
                          <div key={_C_cat_res_idx}>
                            {_C_category_results.results.length ? (
                              <div className="border-bottom border-2 border-primary pb-3 mb-3 text-muted">
                                <h3>{_category_name}</h3>
                              </div>
                            ) : null}
                            {_C_category_results.results.length ? (
                              <div className="mb-4">
                                {(this.state.persistentState.resultsCategory == "ALL"
                                  ? _C_category_results.results.slice(0, 5)
                                  : _C_category_results.results
                                ).map((_C_result, _C_idx) => {
                                  let _icon =
                                    _C_result.type == "PROBE"
                                      ? "icon-probe"
                                      : _C_result.type == "MEASURE" &&
                                        _C_result.data.measure.archived != null
                                      ? "icon-archive"
                                      : _C_result.type == "MEASURE" &&
                                        _C_result.data.measure.archived == null &&
                                        _C_result.data.measure.paused != null
                                      ? "icon-pause"
                                      : _C_result.type == "MEASURE" &&
                                        _C_result.data.measure.archived == null &&
                                        _C_result.data.measure.paused == null
                                      ? "icon-graph-bar"
                                      : _C_result.type == "ESSID"
                                      ? /^Ethernet$/.test(_C_result.data.result_title)
                                        ? "icon-ethernet"
                                        : "icon-wifi"
                                      : _C_result.type == "TEST"
                                      ? "icon-script"
                                      : "icon-router";
                                  let _label =
                                    _C_result.type == "PROBE"
                                      ? "PROBE"
                                      : _C_result.type == "MEASURE" &&
                                        _C_result.data.measure.archived != null
                                      ? "ARCHIVED"
                                      : _C_result.type == "MEASURE" &&
                                        _C_result.data.measure.archived == null &&
                                        _C_result.data.measure.paused != null
                                      ? "PAUSED"
                                      : _C_result.type == "MEASURE" &&
                                        _C_result.data.measure.archived == null &&
                                        _C_result.data.measure.paused == null
                                      ? "RUNNING"
                                      : _C_result.type == "ESSID"
                                      ? /^Ethernet$/.test(_C_result.data.result_title)
                                        ? "NETWORK"
                                        : "ESSID"
                                      : _C_result.type == "TEST"
                                      ? "TEST"
                                      : "AP";

                                  let _link = "/";
                                  if (_C_result.data.probe && _C_result.data.measure) {
                                    _link =
                                      _C_result.type == "PROBE"
                                        ? "/" + _C_result.data.probe.prb_id + "/active"
                                        : _C_result.type == "MEASURE"
                                        ? "/" +
                                          _C_result.data.probe.prb_id +
                                          "/" +
                                          (_C_result.data.measure.archived
                                            ? "archived"
                                            : _C_result.data.measure.paused
                                            ? "paused"
                                            : "active") +
                                          "/" +
                                          _C_result.data.measure.cssid
                                        : _C_result.type == "ESSID"
                                        ? "/" +
                                          _C_result.data.probe.prb_id +
                                          "/" +
                                          (_C_result.data.measure.archived
                                            ? "archived"
                                            : _C_result.data.measure.paused
                                            ? "paused"
                                            : "active") +
                                          "/" +
                                          _C_result.data.measure.cssid
                                        : _C_result.type == "TEST"
                                        ? "/" +
                                          _C_result.data.probe.prb_id +
                                          "/" +
                                          (_C_result.data.measure.archived
                                            ? "archived"
                                            : _C_result.data.measure.paused
                                            ? "paused"
                                            : "active") +
                                          "/" +
                                          _C_result.data.measure.cssid
                                        : "/" +
                                          _C_result.data.probe.prb_id +
                                          "/" +
                                          (_C_result.data.measure.archived
                                            ? "archived"
                                            : _C_result.data.measure.paused
                                            ? "paused"
                                            : "active") +
                                          "/" +
                                          _C_result.data.measure.cssid +
                                          "/" +
                                          _C_result.data.bssid.split(":").join("");
                                  } else {
                                    _link = "/" + _C_result.data.probe.prb_id + "/active";
                                  }

                                  return (
                                    <Link
                                      to={_link}
                                      key={_C_idx}
                                      style={{
                                        ...{ color: "inherit", textDecoration: "none" },
                                      }}
                                    >
                                      <Panel
                                        rounded
                                        className={
                                          "mb-2" +
                                          (_C_result.data.age &&
                                          _now - _C_result.data.age > 60 * 60 * 24 * 7
                                            ? " aged"
                                            : "")
                                        }
                                      >
                                        <div className="d-flex">
                                          <div
                                            style={{ width: "80px" }}
                                            className="flex-shrink-1 border-right border-1 border-gray400 mr-3 pr-3"
                                          >
                                            <div className="d-flex justify-content-center text-primary">
                                              <div className="flex-shrink-1 text-center">
                                                <h4>
                                                  <span className={_icon} />
                                                </h4>
                                              </div>
                                            </div>
                                            <small>
                                              <div className="text-center py-1">
                                                <strong>
                                                  <span className="text-nowrap">
                                                    {_label}
                                                  </span>
                                                </strong>
                                              </div>
                                            </small>
                                          </div>
                                          <div>
                                            <div className="d-flex align-items-center text-primary">
                                              <span>
                                                <h5 style={{ lineHeight: "28px" }}>
                                                  {_C_result.data.result_title}
                                                </h5>
                                              </span>
                                              {_C_result.type == "AP" &&
                                              !/^[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}:[a-fA-F0-9]{2}$/.test(
                                                _C_result.data.result_title
                                              ) ? (
                                                <span className="ml-2">
                                                  ({_C_result.data.bssid})
                                                </span>
                                              ) : null}
                                              {_C_result.data.age &&
                                              _now - _C_result.data.age >
                                                60 * 60 * 24 * 7 ? (
                                                <small className="ml-2 text-muted">
                                                  [Old - Last update{" "}
                                                  {this.getAppContext()
                                                    .momentjs(_C_result.data.age, "X")
                                                    .format("L LT")}
                                                  ]
                                                </small>
                                              ) : null}
                                            </div>
                                            <small className="d-flex align-items-center">
                                              <Section
                                                className={
                                                  this.getAppContext().media.isMobile ||
                                                  this.getAppContext().media.isTablet
                                                    ? "flex-grow-1"
                                                    : ""
                                                }
                                                designType="wide"
                                                layoutManager="grid"
                                                elementsPerRow={
                                                  this.getAppContext().media.isMobile ||
                                                  this.getAppContext().media.isTablet
                                                    ? 1
                                                    : 5
                                                }
                                                gridSpacing={1}
                                                gridSpacingColor={
                                                  this.getAppContext().colors.gray300
                                                }
                                              >
                                                {_C_result.type == "PROBE"
                                                  ? [
                                                      <div
                                                        key="probe.0"
                                                        className={
                                                          "flex-shrink-1 py-1" +
                                                          (!this.getAppContext().media
                                                            .isMobile &&
                                                          !this.getAppContext().media
                                                            .isTablet
                                                            ? " pr-2"
                                                            : "")
                                                        }
                                                      >
                                                        <strong className="text-muted text-nowrap">
                                                          ID:
                                                        </strong>
                                                        <strong className="pl-2">
                                                          <span className="text-nowrap">
                                                            {_C_result.data.probe
                                                              .prb_id || "-"}
                                                          </span>
                                                        </strong>
                                                      </div>,
                                                      <div
                                                        key="probe.1"
                                                        className={
                                                          "flex-shrink-1 py-1" +
                                                          (!this.getAppContext().media
                                                            .isMobile &&
                                                          !this.getAppContext().media
                                                            .isTablet
                                                            ? " px-2"
                                                            : "")
                                                        }
                                                      >
                                                        <strong className="text-muted text-nowrap">
                                                          PROBE STATUS:
                                                        </strong>
                                                        <strong className="pl-2">
                                                          <span className="text-nowrap">
                                                            {_C_result.data.probe
                                                              .probe_status &&
                                                            _C_result.data.probe
                                                              .probe_status != null
                                                              ? this.getAppContext().conf
                                                                  .SETTINGS_NAME[
                                                                  _C_result.data.probe
                                                                    .probe_status
                                                                ].label
                                                              : "Deployed"}
                                                          </span>
                                                        </strong>
                                                      </div>,
                                                      <div
                                                        key="probe.2"
                                                        className={
                                                          "flex-shrink-1 py-1" +
                                                          (!this.getAppContext().media
                                                            .isMobile &&
                                                          !this.getAppContext().media
                                                            .isTablet
                                                            ? " px-2"
                                                            : "")
                                                        }
                                                      >
                                                        <strong className="text-muted text-nowrap">
                                                          CONFIGURATION:
                                                        </strong>
                                                        <strong className="pl-2">
                                                          <span className="text-nowrap">
                                                            {_C_result.data.probe
                                                              .measures_conf &&
                                                            _C_result.data.probe
                                                              .measures_conf != null
                                                              ? this.getAppContext().conf
                                                                  .SETTINGS_NAME[
                                                                  _C_result.data.probe
                                                                    .measures_conf
                                                                ].label
                                                              : "Manual"}
                                                          </span>
                                                        </strong>
                                                      </div>,
                                                    ]
                                                  : null}
                                                {_C_result.type == "MEASURE" ? (
                                                  <div
                                                    className={
                                                      "flex-shrink-1 py-1" +
                                                      (!this.getAppContext().media
                                                        .isMobile &&
                                                      !this.getAppContext().media.isTablet
                                                        ? " pr-2"
                                                        : "")
                                                    }
                                                  >
                                                    <strong className="text-muted text-nowrap">
                                                      RUNS ON:
                                                    </strong>
                                                    <strong className="pl-2">
                                                      <span className="text-nowrap">
                                                        <span className="icon-probe mr-1" />{" "}
                                                        {_C_result.data.probe.name || "-"}{" "}
                                                        <span className="text-muted">
                                                          (ID:{" "}
                                                          {_C_result.data.probe.prb_id ||
                                                            "-"}
                                                          )
                                                        </span>
                                                      </span>
                                                    </strong>
                                                  </div>
                                                ) : null}
                                                {_C_result.type == "ESSID" ||
                                                _C_result.type == "AP"
                                                  ? [
                                                      <div
                                                        key="essid_app.0"
                                                        className={
                                                          "flex-shrink-1 py-1" +
                                                          (!this.getAppContext().media
                                                            .isMobile &&
                                                          !this.getAppContext().media
                                                            .isTablet
                                                            ? " pr-2"
                                                            : "")
                                                        }
                                                      >
                                                        <strong className="text-muted text-nowrap">
                                                          MEASURED BY:
                                                        </strong>
                                                        <strong className="pl-2">
                                                          <span className="text-nowrap">
                                                            <span className="icon-graph-bar mr-1" />{" "}
                                                            {_C_result.data.measure &&
                                                            _C_result.data.measure.name
                                                              ? _C_result.data.measure
                                                                  .name
                                                              : "-"}
                                                          </span>
                                                        </strong>
                                                      </div>,
                                                      <div
                                                        key="essid_app.1"
                                                        className={
                                                          "flex-shrink-1 py-1" +
                                                          (!this.getAppContext().media
                                                            .isMobile &&
                                                          !this.getAppContext().media
                                                            .isTablet
                                                            ? " px-2"
                                                            : "")
                                                        }
                                                      >
                                                        <strong className="text-muted text-nowrap">
                                                          RUNS ON:
                                                        </strong>
                                                        <strong className="pl-2">
                                                          <span className="text-nowrap">
                                                            <span className="icon-probe mr-1" />{" "}
                                                            {_C_result.data.probe.name ||
                                                              "-"}{" "}
                                                            <span className="text-muted">
                                                              (
                                                              {_C_result.data.probe
                                                                .prb_id || "-"}
                                                              )
                                                            </span>
                                                          </span>
                                                        </strong>
                                                      </div>,
                                                    ]
                                                  : null}
                                                {_C_result.type == "TEST"
                                                  ? [
                                                      <div
                                                        key="test.0"
                                                        className={
                                                          "flex-shrink-1 py-1" +
                                                          (!this.getAppContext().media
                                                            .isMobile &&
                                                          !this.getAppContext().media
                                                            .isTablet
                                                            ? " pr-2"
                                                            : "")
                                                        }
                                                      >
                                                        <strong className="text-muted text-nowrap">
                                                          MEASURE:
                                                        </strong>
                                                        <strong className="pl-2">
                                                          <span className="text-nowrap">
                                                            <span
                                                              className={
                                                                _C_result.data.measure
                                                                  .archived != null
                                                                  ? "icon-archive mr-1"
                                                                  : _C_result.data.measure
                                                                      .archived == null &&
                                                                    _C_result.data.measure
                                                                      .paused != null
                                                                  ? "icon-pause mr-1"
                                                                  : _C_result.data.measure
                                                                      .archived == null &&
                                                                    _C_result.data.measure
                                                                      .paused == null
                                                                  ? "icon-graph-bar mr-1"
                                                                  : ""
                                                              }
                                                            />{" "}
                                                            {_C_result.data.measure
                                                              .name || "-"}
                                                          </span>
                                                        </strong>
                                                      </div>,
                                                      <div
                                                        key="test.1"
                                                        className={
                                                          "flex-shrink-1 py-1" +
                                                          (!this.getAppContext().media
                                                            .isMobile &&
                                                          !this.getAppContext().media
                                                            .isTablet
                                                            ? " px-2"
                                                            : "")
                                                        }
                                                      >
                                                        <strong className="text-muted text-nowrap">
                                                          {_C_result.data.measure
                                                            .archived != null
                                                            ? "ARCHIVED ON:"
                                                            : _C_result.data.measure
                                                                .archived == null &&
                                                              _C_result.data.measure
                                                                .paused != null
                                                            ? "PAUSED ON:"
                                                            : _C_result.data.measure
                                                                .archived == null &&
                                                              _C_result.data.measure
                                                                .paused == null
                                                            ? "RUNNING ON:"
                                                            : "ON:"}
                                                        </strong>
                                                        <strong className="pl-2">
                                                          <span className="text-nowrap">
                                                            <span className="icon-probe mr-1" />{" "}
                                                            {_C_result.data.probe.name ||
                                                              "-"}{" "}
                                                            <span className="text-muted">
                                                              (
                                                              {_C_result.data.probe
                                                                .prb_id || "-"}
                                                              )
                                                            </span>
                                                          </span>
                                                        </strong>
                                                      </div>,
                                                    ]
                                                  : null}
                                              </Section>
                                            </small>
                                          </div>
                                        </div>
                                      </Panel>
                                    </Link>
                                  );
                                })}
                                {this.state.persistentState.resultsCategory == "ALL" &&
                                _C_category_results.results.length > 5 ? (
                                  <div>
                                    <ReactOButton
                                      text
                                      color="primary"
                                      onClick={() => {
                                        this.context._LayoutBody.scrollTop();
                                        this.setResultsCategory(_C_category_results.type);
                                      }}
                                    >
                                      ...show all {_category_name} (
                                      <strong>
                                        {_C_category_results.results.length - 5}
                                      </strong>{" "}
                                      more)
                                    </ReactOButton>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                        );
                      }
                    )
                  : null}

                {}
              </div>
            ) : (
              <div className="text-center text-muted">0 results found</div>
            )}
          </_LoadingWrapper>
        </Section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps)(
  contextProvider(
    SearchResults,
    //	withDefinedContext(SearchResults, 'SearchResults', context_exposed_methods),
    {
      retrieve: ["_LayoutBody"],
    }
  )
);
